<template lang="pug">
.breadcrumbs-container(v-if="showBreadcrumbs" :class="{ v2: useV2Styles }")
  .fixed-width-tweak-upper-max
    ol(itemscope itemtype="https://schema.org/BreadcrumbList")
      li.fragment-container(v-for="(fragment, index) in fragments" :key="fragment.title" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem")
        template(v-if="useV2Styles")
          a.fragment.upper.bold.brand-color-1.font-xxsmall.max-at-tweak(v-if="fragment.url" :href="fragment.url" @click.prevent="trackMREventAndRedirect('Breadcrumbs - Link Clicked', fragment.url, { url: fragment.url, title: fragment.title })" itemprop="item" itemscope :itemid="fragment.url" itemtype="https://schema.org/WebPage")
            span(itemprop="name") {{ fragment.title }}

          .fragment.upper.bold.text-color-3.font-xxsmall.max-at-tweak(v-else)
            span(itemprop="name") {{ fragment.title }}

          meta(itemprop="position" :content="index + 1")

          span.caret-right(v-if="index + 1 < fragments.length") &nbsp;&gt;&nbsp;

        template(v-else-if="fragment.title")
          a.fragment.font-xsmall.brand-color-2.underline(v-if="fragment.url" :href="fragment.url" @click.prevent="trackMREventAndRedirect('Breadcrumbs - Link Clicked', fragment.url, { url: fragment.url, title: fragment.title })" itemprop="item" itemscope :itemid="fragment.url" itemtype="https://schema.org/WebPage")
            span(itemprop="name") {{ fragment.title }}

          .fragment.font-xsmall.brand-color-2(v-else)
            span(itemprop="name") {{ fragment.title }}

          meta(itemprop="position" :content="index + 1")

          .caret-right-icon(v-if="index + 1 < fragments.length")
            MrIcon(name="caret-down")

</template>

<script>
  import { mapState, mapGetters } from "vuex";

  import MrIcon from "@components/MrIcon";

  export default {
    name: "Breadcrumbs",

    components: {
      MrIcon
    },

    props: {
      /**
       * The array object property structure is: {title: 'Radiant Color', url: '/radiant-color'}}
       */
      fragments: {
        type: Array,
        required: true,
        default: () => []
      }
    },

    computed: {
      ...mapState('cms', ['cmsSettings']),
      ...mapGetters('pdp', ['hasActiveSub']),

      useV2Styles() {
        return (this.cmsSettings?.usePdpV2 && !this.hasActiveSub) || this.cmsSettings?.usePdpV3;
      },

      showBreadcrumbs() {
        if (!this.fragments.length) {
          return false;
        }

        if (Array.isArray(this.fragments)) {
          return this.fragments.some(fragment => !!fragment.title);
        }

        return false;
      }
    },
  };
</script>

<style lang="stylus" scoped>
  .breadcrumbs-container
    width 100%
    background-color ui-color-3
    
    &.v2
      background-color color-white
      white-space nowrap
      
      ol
        padding 0.5em 0.75em
      
      .caret-right
        margin-top -0.15em
    
    ol
      margin 0
      padding 1em
      list-style none

      @media mq-desktop-plus
        padding 1.5em 2em

    .fragment-container
      display inline-flex
      align-content center

    .caret-right-icon
      display inline-block
      transform rotate(270deg)
      margin 0 0.3em
      color brand-color-2

</style>
